import React from 'react'
import MenuPages from './MenuPages'
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const BootomFooterPages = () => {

    const addPagesPermission = checkPermission(
        permissionsConfig.addBottomFooterPages.role,
        permissionsConfig.addBottomFooterPages.action,
        permissionsConfig.addBottomFooterPages.type
    );

    const editPagesPermission = checkPermission(
        permissionsConfig.editBottomFooterPages.role,
        permissionsConfig.editBottomFooterPages.action,
        permissionsConfig.editBottomFooterPages.type
    );
        
    const deletePagesPermission = checkPermission(
        permissionsConfig.deleteBottomFooterPages.role,
        permissionsConfig.deleteBottomFooterPages.action,
        permissionsConfig.deleteBottomFooterPages.type
    );

    return (
        <MenuPages title="Bottom Footer Pages" type="3" pageFrom="bottom-footer-pages" addPagesPermission={addPagesPermission} editPagesPermission={editPagesPermission} deletePagesPermission={deletePagesPermission}></MenuPages>
    )
}

export default BootomFooterPages